import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import BasicColumnImpl from "~/components/BasicColumn";
import RichText from "~/components/RichText";
import Wrapper from "~/components/SliceWrapper";

function gridCols(data: any) {
  switch (data) {
    case 1:
    case "1":
      return "grid-cols-1";
    case 2:
    case "2":
      return "grid-cols-2";
    case 3:
    case "3":
      return "grid-cols-3";
    default:
      return "";
  }
}

/**
 * Props for `Columns`.
 */
export type ColumnsProps = SliceComponentProps<Content.ColumnsSlice>;

/**
 * Component for "Columns" Slices.
 */
const Columns: FC<ColumnsProps> = ({ slice }) => {
  return (
    // @ts-expect-error — SliceWrapper is an untyped JS component
    <Wrapper
      data-analytics-component="columns"
      slice={slice}
      cssClass={`${slice.primary.alt_headings ? "alt-headings" : ""}`}
    >
      {Boolean(slice.primary.heading.length) && (
        <div className="rte section-heading">
          <RichText field={slice.primary.heading} />
        </div>
      )}
      <div
        className={`grid-mb-on-mobile gap-8 lg:grid ${gridCols(
          slice.primary.column_count,
        )} type-${slice.primary.type || "default"} ${
          slice.primary.flush_images ? "flush-images" : ""
        }`}
      >
        {slice.primary.columns.map((col, index) => (
          <BasicColumnImpl key={index} data={col} type={slice.primary.type} />
        ))}
      </div>
    </Wrapper>
  );
};

export default Columns;
